module.exports = __webpack_public_path__ + "img/t5-8.7f1ac0ee.svg";